import React, {Component} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';

import setPrerenderReady from '../services/utils/setPrerenderReady';
import {injectIntl} from '../Intl';
import NotFound from "./NotFound";
import {loadPageByUrl} from '../services/services/PageInfoService';
import {setPageInfo} from "../services/actions/PageInfo";

const Pages = React.lazy(() => import('./Pages'));

const mapStateToProps = state => ({
    lang: state.App.lang,
    supportedLanguages: state.App.supportedLanguages,
});

const mapDispatchToProps = dispatch => ({
    setPageInfo: (pageInfo) => dispatch(setPageInfo(pageInfo))
});

class LandingSwitcher extends Component {
    state = {
        landingData: null
    };

    componentDidMount() {
        setPrerenderReady();

        const {lang, setPageInfo} = this.props;

        const s7PageInit = typeof(window.s7PageInit)!=='undefined' ? window.s7PageInit : {};

        if (!(typeof (s7PageInit) !== "undefined" && ('page' in s7PageInit)
            && (lang in s7PageInit.page))) {

            loadPageByUrl({lang}).then((response) => {
                if (response.data !== "") setPageInfo(response.data);
                this.setState({
                    landingData: response.data !== "" ? response.data : 404
                });
            })
            .catch(() => {
                this.setState({
                    landingData: 404
                });
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        const {lang} = this.props;
        const {landingData} = this.state;

        return nextProps.lang !== lang || nextState.landingData !== landingData;
    }

    constructor(props) {
        super(props);
        const {lang} = this.props;

        const s7PageInit = typeof(window.s7PageInit)!=='undefined' ? window.s7PageInit : {};

        if ( ('page' in s7PageInit) && (lang in s7PageInit.page)) {
            this.state = {
                landingData: s7PageInit.page[lang]
            };
        }
    }

    render() {
        const {landingData} = this.state;
        return landingData !== null ? (landingData !== 404 ? <Pages
                data={landingData}/> :
            <NotFound/>) : null;
    }
}

export default (injectIntl(connect(mapStateToProps, mapDispatchToProps)(LandingSwitcher)));